import { GetterTree } from 'vuex'
import WorkingTimeState, { IWorkingTime } from './states'
import { State } from '@/store/store'
import _ from 'lodash'
import { IJob } from '../job/states'

const getters: GetterTree<WorkingTimeState, State> = {
  startWorkingTimeLists: (state) => (
    patientType: string, jobType: string, period: string, time: IJob['time'], index: number,
  ): Array<{
    text?: string,
    value?: string,
  }> => {
    const data = _.filter(
      state.list.data,
      (item) => (item.period === period) &&
        _.includes(item.jobTypes, jobType) &&
        _.includes(item.patientTypes, patientType) &&
        !_.some(time, (t, i) => (i !== index) && (
          (t.startTime === item.startTime)
          && (t.endTime === item.endTime)
          && (t.price === item.price)
        )),
    )
    return data.map((each) => {
      return {
        text: each.startTime,
        value: each.startTime,
      }
    })
  },
  endWorkingTimeLists: (state) => (
    patientType: string, jobType: string, period: string, time: IJob['time'], index: number, startTime: string,
  ): Array<{
    text?: string,
    value?: string,
  }> => {
    const data = _.filter(
      state.list.data,
      (item) => (item.period === period) &&
        (item.startTime === startTime) &&
        _.includes(item.jobTypes, jobType) &&
        _.includes(item.patientTypes, patientType) &&
        !_.some(time, (t, i) => (i !== index) && (
          (t.startTime === item.startTime)
          && (t.endTime === item.endTime) && (t.price === item.price)
        )),
    )
    return data.map((each) => {
      return {
        text: each.endTime,
        value: each.endTime,
      }
    })
  },
  priceWorkingTimeLists: (state) => (
    patientType: string, jobType: string, period: string, startTime: string, endTime: string,
  ): Array<{
    text?: string,
    value?: {price: number, food: number},
  }> => {
    const data = _.filter(
      state.list.data,
      (item) => (item.startTime === startTime) &&
        (item.endTime === endTime) &&
        (item.period === period) &&
        _.includes(item.jobTypes, jobType) &&
        _.includes(item.patientTypes, patientType),
    )
    return data.map((each) => {
      return {
        text: each.price + (each.food ? `&อาหาร${each.food}/วัน` : ''),
        value: _.pick(each, ['price', 'food']),
      }
    })
  },
  periodName: (state) => (jobType: string) => {
    const found = _.find(state.list.data, (item) => _.includes(item.jobTypes, jobType))
    return found ? found.period : ''
  },
}

export default getters
